export const RecoveryTokenStatuses = {
  IS_VALID: 'IS_VALID',
  IS_NOT_VALID: 'IS_NOT_VALID',
  IS_NOT_CHECKED: 'IS_NOT_CHECKED'
}

export type RecoveryTokenStatuses = typeof RecoveryTokenStatuses



// WEBPACK FOOTER //
// ./src/constants/authentication.ts